import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import React, { useState } from 'react';
import { StyledMenu, StyledMenuButton } from './styles';
export function WeddingMenu(props) {
  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var cn = open ? 'is-active' : '';
  return /*#__PURE__*/React.createElement(StyledMenu, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style,
    open: open,
    edit: props.edit
  }, process.env.ENV_RAW ? null : props.uiEvents), /*#__PURE__*/React.createElement(StyledMenuButton, {
    className: cn,
    onClick: function onClick() {
      return setOpen(function (i) {
        return !i;
      });
    },
    open: open
  }, /*#__PURE__*/React.createElement("span", {
    className: "hamburger-box"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hamburger-inner"
  }))), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setOpen(false);
    }
  }, props.children));
}